import { httpResource } from 'core/resources/httpResource';
import { BaseRestResource } from '@snap-alex/domain-js';
import { cityResourceUrl } from '../constants';

class CityResource extends BaseRestResource {}

export const cityResource = new CityResource(httpResource, cityResourceUrl);
